import React, {Component} from 'react';
import {Row, Col, Container} from 'react-bootstrap';
import logo from '../assets/logo.svg';
import FooterLinks from '../components/footer/footer-links';

class AppFooter extends Component {
  render() {
    return (
      <Container>
        <Row className="le-footer">
          <Col md={8} sm={12}>
          <img src={logo} alt="logo" className="le-logo"/>
          <div className="address-container">
            <div>
                <p>VISIT US</p>
                <p>
                  3 Plane Hill Rd
                  Washington, New Jersey(NJ), 07882
                </p>
            </div>
            <div>
                <p>CALL US</p>
                <p>
                  +91 9086893656
                </p>
            </div>
            <div>
                <p>EMAIL US</p>
                <p>
                  support@lineandedges.com
                </p>
            </div>
          </div>
          </Col>
          <Col md={4} sm={12}>
            <FooterLinks />
          </Col>

          <Col md={12}>
            <hr/>
          </Col>

          <Col md={12}>
            <p>
              copyright @ 2020 | line and edges
            </p>

            <p>
              Terms and conditions | Privacy policy
            </p>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default AppFooter;